function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import Common from "./includes/Common";
import { Skeleton, notification, Button, List, Space, Tag, Modal } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import { CheckSquare, XSquare } from "react-bootstrap-icons";
import { useOutletContext } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;

var Autorisations = function Autorisations() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      requestList = _useState2[0],
      setRequestList = _useState2[1]; //const [dataChanged, setDataChanged] = ; useOutletContext(); 


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dataChanged = _useState4[0],
      setDataChanged = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedRequest = _useState8[0],
      setSelectedRequest = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      inquiryList = _useState10[0],
      setInquiryList = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedExpense = _useState12[0],
      setSelectedExpense = _useState12[1];

  var handleApprove = function handleApprove(r) {
    setSelectedRequest(r);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous l'approbation de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Autoriser pour l'acc\xE8s de ", r.customer.firstname, " ", r.customer.lastname, " aux prestations en r\xE9sum\xE9"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approverequest", {
          bill_id: r.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  var handleReject = function handleReject(r) {
    setSelectedRequest(r);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous le rejet de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Refuser l'acc\xE8s de ", r.customer.firstname, " ", r.customer.lastname, " aux prestations en r\xE9sum\xE9"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "rejectrequest", {
          bill_id: r.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  var handleApproveExpense = function handleApproveExpense(t) {
    setSelectedExpense(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous l'approbation de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Autoriser la sortie de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.firstname, " ", t.user.lastname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvetransaction", {
          cash_transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  var handleRejectExpense = function handleRejectExpense(t) {
    setSelectedExpense(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous le rejet de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Sortie de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.firstname, " ", t.user.lastname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvetransaction", {
          transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getrequests/" + Common.currentUser.id).then(function (response) {
      setRequestList([]);
      setInquiryList([]);

      if (response.data.status == 200) {
        setRequestList(response.data.requests);
        setInquiryList(response.data.inquiries);
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue. Code : " + error.toString()
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 7,
          md: 6,
          children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          }), /*#__PURE__*/_jsx(List, {
            loading: isDataLoading,
            itemLayout: "horizontal",
            dataSource: requestList,
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                actions: [/*#__PURE__*/_jsx(Button, {
                  style: {
                    color: "#446162"
                  },
                  onClick: function onClick() {
                    handleApprove(item);
                  },
                  type: "default",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "APPROUVER"
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  style: {
                    color: "#7B565D"
                  },
                  onClick: function onClick() {
                    handleReject(item);
                  },
                  type: "default",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "REJETTER"
                  })
                })],
                children: /*#__PURE__*/_jsx(Skeleton, {
                  avatar: true,
                  title: false,
                  loading: isDataLoading,
                  active: true,
                  children: /*#__PURE__*/_jsx(List.Item.Meta, {
                    title: item.customer && /*#__PURE__*/_jsxs("b", {
                      children: [item.customer.firstname, " ", item.customer.lastname]
                    }),
                    description: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("ul", {
                        children: item.bill_items.map(function (i) {
                          return /*#__PURE__*/_jsx("li", {
                            children: i.business_account_medical_item.label
                          }, i.id);
                        })
                      }), /*#__PURE__*/_jsxs("div", {
                        children: [item.discount > 0 && /*#__PURE__*/_jsxs(Tag, {
                          color: "#7B565D",
                          children: ["REMISE ", item.discount, " %"]
                        }), item.is_pda == 1 && /*#__PURE__*/_jsxs(Tag, {
                          color: "#82675B",
                          children: [" RE\xC7U: ", item.paid_amount.toLocaleString("Fr"), " GNF"]
                        }), item.is_pda == 1 && /*#__PURE__*/_jsxs(Tag, {
                          color: "#225F7B",
                          children: [" RESTE: ", (item.total_amount - item.paid_amount).toLocaleString("Fr"), " GNF"]
                        }), item.is_pda == 1 && /*#__PURE__*/_jsx(Tag, {
                          color: "#5B8082",
                          children: " PDA"
                        })]
                      })]
                    })
                  })
                })
              });
            }
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              minHeight: "400px",
              background: "#FFFFFF",
              padding: "12px",
              borderRadius: "5px",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px"
            },
            children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }), /*#__PURE__*/_jsx(List, {
              loading: isDataLoading,
              itemLayout: "horizontal",
              dataSource: inquiryList,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsx(List.Item, {
                  actions: [/*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#446162"
                    },
                    onClick: function onClick() {
                      handleApproveExpense(item);
                    },
                    type: "default",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [" ", /*#__PURE__*/_jsx(CheckSquare, {
                        size: 26
                      })]
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#7B565D"
                    },
                    onClick: function onClick() {
                      handleRejectExpense(item);
                    },
                    type: "default",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [" ", /*#__PURE__*/_jsx(XSquare, {
                        size: 26
                      })]
                    })
                  })],
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    avatar: true,
                    title: false,
                    loading: isDataLoading,
                    active: true,
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      title: item.user && /*#__PURE__*/_jsxs("b", {
                        children: [item.user.firstname, " ", item.user.lastname]
                      }),
                      description: /*#__PURE__*/_jsxs("div", {
                        children: [item.expense_category.ecode == "PRE" ? "demandes un prêt" : "à fait une demande", " de ", /*#__PURE__*/_jsxs("b", {
                          children: [item.amount.toLocaleString("Fr"), " GNF"]
                        }), item.comment.length > 0 && /*#__PURE__*/_jsxs("div", {
                          children: [/*#__PURE__*/_jsx(Tag, {
                            color: "#446162",
                            children: "Commentaire"
                          }), /*#__PURE__*/_jsx("p", {
                            children: item.comment
                          })]
                        })]
                      })
                    })
                  })
                });
              }
            })]
          })
        })]
      })
    })
  });
};

export default Autorisations;